import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { useLocation } from 'react-router-dom';

const ARCHIVE_START_YEAR = 2018;

export const buildStaticNavLinks = () => {
  const links = [{ label: 'Recent', href: '/publications' }];
  for (
    let year = new Date().getFullYear();
    year >= ARCHIVE_START_YEAR;
    year--
  ) {
    links.push({ label: String(year), href: `/publications/${year}` });
  }
  links.push({
    label: 'Older Publications',
    href: '/publications/legacy',
  });
  return links;
};

const normalizePath = (path = '') => path.replace(/\/+$/, '') || '/';

const PublicationYearNav = ({ position = 'top' }) => {
  const location = useLocation();
  const navLinks = useMemo(() => buildStaticNavLinks(), []);
  const normalizedPath = normalizePath(location.pathname);
  const isActivePath = (targetPath) =>
    normalizedPath === normalizePath(targetPath);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <nav
      className={`publication-year-archive__years publication-year-archive__page-nav${
        position === 'bottom'
          ? ' publication-year-archive__page-nav--bottom'
          : ''
      }`}
      aria-label="Publication year pages"
    >
      {navLinks.map(({ label, href }) => (
        <UniversalLink
          key={`${position}-${href}`}
          href={href}
          className={`publication-year-archive__nav-btn${
            isActivePath(href)
              ? ' publication-year-archive__nav-btn--active'
              : ''
          }`}
        >
          {label}
        </UniversalLink>
      ))}
      <button
        type="button"
        className="publication-year-archive__nav-btn publication-year-archive__nav-btn--up"
        onClick={scrollToTop}
        aria-label="Back to top"
      >
        ↑
      </button>
    </nav>
  );
};

PublicationYearNav.propTypes = {
  position: PropTypes.oneOf(['top', 'bottom']),
};

export default PublicationYearNav;
